import React from 'react';
import VegaIcon from './vegaIcons';

export default function VegaCTA() {
  return (
    <section className="px-6 lg:px-10" style={{ paddingBottom: '6rem' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div
          className="vd-grad-card-cta relative overflow-hidden"
          style={{ borderRadius: '1.75rem', padding: 'clamp(2.5rem, 5vw, 3.5rem)' }}
        >
          <div className="vd-star-dust absolute inset-0 pointer-events-none" style={{ opacity: 0.25 }} />
          <div style={{ position: 'relative', maxWidth: '48rem' }}>
            <h2
              className="vd-font-display"
              style={{
                fontSize: 'clamp(2rem, 4.5vw, 3.25rem)',
                color: 'rgb(15,23,42)',
                lineHeight: 1.05,
                textWrap: 'balance',
              }}
            >
              Schedule a call <br />
              and get <span style={{ fontStyle: 'italic' }}>early access to Vega.</span>
            </h2>

            <div style={{ marginTop: '2rem', display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
              <a
                href="https://calendly.com/raj-archetypical"
                target="_blank"
                rel="noreferrer"
                className="vd-btn-primary"
              >
                Book a demo <VegaIcon name="arrow" className="w-4 h-4" />
              </a>
              <a
                href="https://www.fundable.com/archetypical-software-vega"
                target="_blank"
                rel="noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.65rem 1.25rem',
                  borderRadius: '999px',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: 'rgb(15,23,42)',
                  background: 'rgba(255,255,255,.7)',
                  transition: 'background 0.15s ease',
                  fontFamily: '"Inter Tight", system-ui, sans-serif',
                }}
                onMouseOver={e => e.currentTarget.style.background = 'white'}
                onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,.7)'}
              >
                Become an investor
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
